module.exports = __webpack_public_path__ + "assets/img/jenkins_build_output.f2e46c29.png";